import { CLASSNAME, type CategoryItem } from '@skin-seoul/service';
import { Box, Button, Grid, GridItem } from '@skin-seoul/design-system';
import NextImage from 'next/image';
import { SafeLink } from '@/components/ui/SafeLink';
type BrandSectionProps = {
  items: CategoryItem[];
  onClose?: () => void;
};
const BrandSection = ({
  items,
  onClose
}: BrandSectionProps) => {
  return <>
      <Grid templateColumns="repeat(2, minmax(0, 1fr))" gap="8px" padding="8px" backgroundColor="neutral.50" borderRadius="8px" data-sentry-element="Grid" data-sentry-source-file="BrandSection.tsx">
        {items.map(item => <GridItem key={item.name} textAlign="center" minWidth={0}>
            <SafeLink href={item.url} unstyled onClick={onClose}>
              <Box width="100%" height="60px" display="flex" alignItems="center" justifyContent="center" backgroundColor="generic.0" borderRadius="6px" padding="8px" cursor="pointer">
                <NextImage src={item.imageUrl ?? ''} alt={item.imageAlt ?? ''} width={120} height={44} style={{
              objectFit: 'contain',
              width: '100%',
              height: '100%',
              maxWidth: '120px',
              maxHeight: '44px'
            }} />
              </Box>
            </SafeLink>
          </GridItem>)}
      </Grid>
      <Box textAlign="center" mt="24px" mb="16px" data-sentry-element="Box" data-sentry-source-file="BrandSection.tsx">
        <Box as="span" width="100%" maxWidth="280px" display="inline-block" data-sentry-element="Box" data-sentry-source-file="BrandSection.tsx">
          <SafeLink unstyled href="/brand/" onClick={onClose} data-sentry-element="SafeLink" data-sentry-source-file="BrandSection.tsx">
            <Button variant="outline" width="100%" borderColor="primary.500" color="primary.500" borderRadius="8px" height="48px" className={CLASSNAME.NOT_TRANSLATE} data-sentry-element="Button" data-sentry-source-file="BrandSection.tsx">
              View More Brands
            </Button>
          </SafeLink>
        </Box>
      </Box>
    </>;
};
export default BrandSection;